import { CommonModule } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'common-message',
	imports: [CommonModule],
	templateUrl: './common-message.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls:['./common-message.widget.scss'],
})
export class CommonMessageWidget {

	public alertType = input<'info' | 'success' | 'warning' | 'error' | 'locked'>('info');
	public closeable = input<boolean>(false);

	public closed = false;
}
